import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Swtich from 'components/switch';
import {
  toggleOnboardingProcess,
} from 'containers/App/reducers/applicationReducer';
import {
  setMessage,
  resetMessage,
} from 'containers/App/reducers/messageReducer';
import './style.css';

class OnboardingProcess extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { isShowOnboardingProcess } = this.props;
    return (
      <div className="header-onboarding-process header-onboarding-process-container">
        <Swtich
          value={isShowOnboardingProcess}
          onToggle={() => {
            this.props.setMessage(
              [<FormattedMessage
                key="1"
                id="SH_Message"
                defaultMessage="訊息"
              />],
              [isShowOnboardingProcess ? <FormattedMessage id="SH_UseGuideOffConfirm" defaultMessage="將關閉常用流程引導" /> : <FormattedMessage id="SH_UseGuideOnConfirm" defaultMessage="將開啟常用流程引導" />],
              () => {
                this.props.toggleOnboardingProcess({
                  enable: !isShowOnboardingProcess,
                });
                this.props.resetMessage();
              },
              this.props.resetMessage,
              '#008BCD',
              this.props.resetMessage
              );
          }}
        />
        <FormattedMessage id="SH_UseGuide" defaultMessage="常用流程引導" />
      </div>
    );
  }
}
OnboardingProcess.propTypes = {
  isShowOnboardingProcess: PropTypes.bool,
  toggleOnboardingProcess: PropTypes.func,
  setMessage: PropTypes.func,
  resetMessage: PropTypes.func,
};

function mapStateToProps(state) {
  const {
    isShowOnboardingProcess,
  } = state.app.application;
  return {
    isShowOnboardingProcess,
  };
}

export default connect(mapStateToProps, {
  setMessage,
  resetMessage,
  toggleOnboardingProcess,
})(OnboardingProcess);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Header/components/OnboardingProcess/index.js
 **/